export default __webpack_public_path__ + "static/media/ketoworkout@3x.91847637.jpg";